import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-project-reports',
  templateUrl: './project-reports.component.html',
  styleUrls: ['./project-reports.component.scss']
})
export class ProjectReportsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
